/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const SERVICE_NAME = "CommitteeBulkInvitePageService";
const log: any = LoggerModule.getInstance();

export class CommitteeBulkInvitePageService {
  private static instance: CommitteeBulkInvitePageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(
    props: any = {}
  ): CommitteeBulkInvitePageService {
    if (!CommitteeBulkInvitePageService.instance) {
      CommitteeBulkInvitePageService.instance =
        new CommitteeBulkInvitePageService(props);
    }
    return CommitteeBulkInvitePageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    const agent = getAgent();
    const compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async sendBulkCommitteeInvites(payload: any) {
    log.blue(SERVICE_NAME, "sendBulkCommitteeInvites payload", payload);
    const agent = getAgent();
    return agent.sendBulkCommitteeInvites(payload);
  }
}
